import { TagBox } from 'devextreme-react/tag-box';
import React from 'react';
export const auditDateRangeConfirmationMessage = "Warning: this case is outside the audit date range. Are you sure you want to continue?";
export const addCaseManualPopupTitles = {ADD: 'Add Case', UPDATE:'Edit Manually Added Case'}
const codeValueEditorConfig = {
  mask: "XXXXXXXX",
  maskRules: {
    X: /([a-z]|[A-Z]|[0-9]|\.)+/,
  },
};
export const editorConfigs = {
  diagnosis: {
    codeValue: codeValueEditorConfig,
    poa: {
      mask: "A",
    },
  },
  lines: {
    procedureModifier: {
      mask: "CC",
    },
    fromServiceDateString: {
      defaultValue: new Date(), //todo
    },
    cptHcpcsCode: {
      mask: "CCCCC",
    },
  },
  codeValue: codeValueEditorConfig,
  nationalDrugUOM:{
    mask: "CC",
  }
};
export const CASE_ADD_LOCATIONS= {
AUDIT_PAGE: "AUDIT_PAGE",
CASE_SEARCH_PAGE: "CASE_SEARCH_PAGE"
}
const diagnosesMapCellTemplate = (container, options) => {
  const noBreakSpace = '\u00A0';
  const text = (options.value || []).map((element) => options.column.lookup.calculateCellValue(element)).join(', ');
  container.textContent = text || noBreakSpace;
  container.title = text;
}


const DiagnoseMapComponent = (props) => {
  return (
    <TagBox
      dataSource={props.data.column.lookup.dataSource}
      defaultValue={props.data.value}
      displayExpr="codeValue"
      valueExpr="codeValue"
      showSelectionControls
      maxDisplayedTags={4}
      applyValueMode="instantly"
      onValueChanged={(e) => {
        if (e.value.length <= 4) {
          props.data.setValue(e.value);
        } else {
          props.data.setValue(e.previousValue);
        }
      }}
      onSelectionChanged={() => {
        props.data.component.updateDimensions();
      }}
    />
  );
};
const linesDiagnosisMapEditor = (e) =>{
  if ((e.parentType === "dataRow" || e.parentType === "filterRow") && e.dataField === "diagnosesMap") {
    e.editorName = "dxTagBox"
    // e.editorOptions.dataSource = self.caseDetail.diagnosesCaseCodes;
    e.editorOptions.dataSource = [];
    e.editorOptions.displayExpr = "codeValue";
    e.editorOptions.valueExpr = "codeValue";
    e.editorOptions.value = e.value || [];
    e.editorOptions.onValueChanged = function (args) {
        if (args.value.length <= 4) {
            e.setValue(args.value);
        }
        else {
            e.setValue(args.previousValue);
        }
    }
}
}
export const accordionItems = [
  {
    accordionId: 1,
    menuName: "Case Header",
    template: "caseTemplate",
  },
  {
    accordionId: 2,
    menuName: "Diagnoses / ICD Procedures / DRG",
    template: "diagnosisTemplate",
  },
  {
    accordionId: 3,
    menuName: "Line Items",
    template: "linesTemplate",
  },
  {
    accordionId: 4,
    menuName: "Codes / Extra Fields",
    template: "codesTemplate",
  },
];

export const columnConfigs = (referenceData) => {
  
 return {
   professional: {
     diagnoses: [
       {
         dataField: "codeValue",
         caption: "Code",
         editorOptions: editorConfigs.diagnosis.codeValue,
         validationRules: [
           {
             type: "required",
             message: "Diagnoses Code is required",
           },
         ],
       },
     ],
     coderWorkflow: {
       enabled: {
         lineItemColumns: [
           {
             dataField: "cptHcpcsCode",
             editorOptions: editorConfigs.lines.cptHcpcsCode,
             caption: "CPT®/HCPCS",
             validationGroup: "auditValidation",
             validationRules: [
               {
                 type: "stringLength",
                 min: 0,
                 max: 48,
                 message: "Procedure Code must be less than 48 characters",
               },
             ],
           },
           {
             dataField: "procedureModifier1",
             editorOptions: editorConfigs.lines.procedureModifier,
             caption: "Mod",
             validationRules: [
               {
                 type: "stringLength",
                 min: 0,
                 max: 2,
                 message: "Mod must be less than 2 characters",
               },
             ],
           },
           {
             dataField: "procedureModifier2",
             editorOptions: editorConfigs.lines.procedureModifier,
             caption: "Mod",
             validationRules: [
               {
                 type: "stringLength",
                 min: 0,
                 max: 2,
                 message: "Mod must be less than 2 characters",
               },
             ],
           },
           {
             dataField: "procedureModifier3",
             editorOptions: editorConfigs.lines.procedureModifier,
             caption: "Mod",
             validationRules: [
               {
                 type: "stringLength",
                 min: 0,
                 max: 2,
                 message: "Mod must be less than 2 characters",
               },
             ],
           },
           {
             dataField: "procedureModifier4",
             editorOptions: editorConfigs.lines.procedureModifier,
             caption: "Mod",
             validationRules: [
               {
                 type: "stringLength",
                 min: 0,
                 max: 2,
                 message: "Mod must be less than 2 characters",
               },
             ],
           },
           {
             dataField: "diagnosesMap",
             caption: "Diagnoses Map",
             width:120,
             editCellComponent: DiagnoseMapComponent,
             cellTemplate: diagnosesMapCellTemplate,
             lookup: {
               dataSource: referenceData?.diagnosisDataSource,
               valueExpr: "codeValue",
               displayExpr: "codeValue",
             },
           },
           {
             dataField: "fromServiceDateString",
             editorOptions: editorConfigs.lines.fromServiceDateString,
             caption: "From Service Date",
             dataType: "date",
           },
           {
             dataField: "toServiceDateString",
             caption: "To Service Date",
             dataType: "date",
           },
           {
             dataField: "serviceUnits",
             dataType: "number",
             caption: "Units",
             alignment: "Center",
             width: 50,
             validationRules: [
               {
                 type: "numeric",
                 message: "Service units should be a number",
               },
             ],
           },
           {
             dataField: "unitOfMeasurement",
             caption: "Unit Type",
             editorOptions: editorConfigs.nationalDrugUOM,
             validationRules: [
               {
                 type: "stringLength",
                 min: 0,
                 max: 2,
                 message: "Unit Type must be less than 2 characters",
               },
             ],
           },
           {
             dataField: "totalChargeAmount",
             caption: "Charges",
             dataType: "number",
             format: "currency",
             precision: 2,
             validationRules: [
               {
                 type: "numeric",
                 message: "Charge should be a number",
               },
             ],
           },
           {
             dataField: "placeOfService",
             caption: "POS",
           },
           {
             dataField: "originalPaymentAmt",
             dataType: "number",
             format: "currency",
             caption: "Original Payment",
             precision: 2,
             validationRules: [
               {
                 type: "numeric",
                 message: "Original Payment Amount should be a number",
               },
             ],
           },
           {
             editorOptions: {
               showClearButton: true,
             },
             dataField: "refCoderId",
             // allowEditing: !self.isCoderAudit,
             width: "150",
             caption: "Coder",
             lookup: {
               dataSource: function(options) {
                 if (!options.data) {
                   return {
                     store: referenceData.lineCoders,
                     filter: options.data
                       ? ["refCoderId", "=", options.data.refCoderId]
                       : null,
                   };
                 } else {
                   return {
                     store: referenceData.lineCoders,
                   };
                 }
               },
               displayExpr: "refCoderDescription",
               valueExpr: "refCoderId",
             },
           },
         ],
       },
       disabled: {
         lineItemColumns: [
           {
             dataField: "cptHcpcsCode",
             editorOptions: editorConfigs.lines.cptHcpcsCode,
             caption: "CPT®/HCPCS",
             validationGroup: "auditValidation",
             validationRules: [
               {
                 type: "stringLength",
                 min: 0,
                 max: 48,
                 message: "Procedure Code must be less than 48 characters",
               },
             ],
           },
           {
             dataField: "procedureModifier1",
             editorOptions: editorConfigs.lines.procedureModifier,
             caption: "Mod",
             validationRules: [
               {
                 type: "stringLength",
                 min: 0,
                 max: 2,
                 message: "Mod must be less than 2 characters",
               },
             ],
           },
           {
             dataField: "procedureModifier2",
             editorOptions: editorConfigs.lines.procedureModifier,
             caption: "Mod",
             validationRules: [
               {
                 type: "stringLength",
                 min: 0,
                 max: 2,
                 message: "Mod must be less than 2 characters",
               },
             ],
           },
           {
             dataField: "procedureModifier3",
             editorOptions: editorConfigs.lines.procedureModifier,
             caption: "Mod",
             validationRules: [
               {
                 type: "stringLength",
                 min: 0,
                 max: 2,
                 message: "Mod must be less than 2 characters",
               },
             ],
           },
           {
             dataField: "procedureModifier4",
             editorOptions: editorConfigs.lines.procedureModifier,
             caption: "Mod",
             validationRules: [
               {
                 type: "stringLength",
                 min: 0,
                 max: 2,
                 message: "Mod must be less than 2 characters",
               },
             ],
           },
           {
             dataField: "diagnosesMap",
             caption: "Diagnoses Map",
             width:120,
             editCellComponent: DiagnoseMapComponent,
             cellTemplate: diagnosesMapCellTemplate,
             lookup: {
               dataSource: referenceData?.diagnosisDataSource,
               valueExpr: "codeValue",
               displayExpr: "codeValue",
             },
           },
           {
             dataField: "fromServiceDateString",
             editorOptions: editorConfigs.lines.fromServiceDateString,
             caption: "From Service Date",
             dataType: "date",
           },
           {
             dataField: "toServiceDateString",
             caption: "To Service Date",
             dataType: "date",
           },
           {
             dataField: "serviceUnits",
             dataType: "number",
             caption: "Units",
             alignment: "Center",
             width: 50,
             validationRules: [
               {
                 type: "numeric",
                 message: "Service units should be a number",
               },
             ],
           },
           {
             dataField: "unitOfMeasurement",
             caption: "Unit Type",
             validationRules: [
               {
                 type: "stringLength",
                 min: 0,
                 max: 2,
                 message: "Unit Type must be less than 2 characters",
               },
             ],
           },
           {
             dataField: "totalChargeAmount",
             caption: "Charges",
             dataType: "number",
             format: "currency",
             precision: 2,
             validationRules: [
               {
                 type: "numeric",
                 message: "Charge should be a number",
               },
             ],
           },
           {
             dataField: "placeOfService",
             caption: "POS",
           },
           {
             dataField: "originalPaymentAmt",
             dataType: "number",
             format: "currency",
             caption: "Original Payment",
             precision: 2,
             validationRules: [
               {
                 type: "numeric",
                 message: "Original Payment Amount should be a number",
               },
             ],
           },
         ],
       },
     },
   },
   hospital: {
     inpatient: {
       diagnoses: [
         {
           dataField: "codeValue",
           caption: "Code",
           editorOptions: editorConfigs.diagnosis.codeValue,
           validationRules: [
             {
               type: "required",
               message: "Diagnoses Code is required",
             },
           ],
         },
         {
           dataField: "certificationInd",
           caption: "POA",
           editorOptions: editorConfigs.diagnosis.poa,
         },
       ],
       coderWorkflow: {
         enabled: {
           lineItemColumns: [
             {
               dataField: "revenueCode",
               caption: "Revenue Code",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 48,
                   message: "Revenue Code must be less than 48 characters",
                 },
               ],
             },
             {
               dataField: "cptHcpcsCode",
               editorOptions: editorConfigs.lines.cptHcpcsCode,
               caption: "CPT®/HCPCS",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 48,
                   message: "Procedure Code must be less than 48 characters",
                 },
               ],
             },
             {
               dataField: "procedureModifier1",
               editorOptions: editorConfigs.lines.procedureModifier,
               caption: "Mod",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 2,
                   message: "Mod must be less than 2 characters",
                 },
               ],
             },
             {
               dataField: "procedureModifier2",
               editorOptions: editorConfigs.lines.procedureModifier,
               caption: "Mod",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 2,
                   message: "Mod must be less than 2 characters",
                 },
               ],
             },
             {
               dataField: "procedureModifier3",
               editorOptions: editorConfigs.lines.procedureModifier,
               caption: "Mod",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 2,
                   message: "Mod must be less than 2 characters",
                 },
               ],
             },
             {
               dataField: "procedureModifier4",
               editorOptions: editorConfigs.lines.procedureModifier,
               caption: "Mod",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 2,
                   message: "Mod must be less than 2 characters",
                 },
               ],
             },
             {
               dataField: "fromServiceDateString",
               editorOptions: editorConfigs.lines.fromServiceDateString,
               caption: "Service Date",
               dataType: "date",
             },
             {
               dataField: "serviceUnits",
               dataType: "number",
               caption: "Units",
               alignment: "Center",
               width: 50,
               validationRules: [
                 {
                   type: "numeric",
                   message: "Service units should be a number",
                 },
               ],
             },
             {
               dataField: "totalChargeAmount",
               dataType: "number",
               caption: "Charges",
               format: "currency",
               precision: 2,
               validationRules: [
                 {
                   type: "numeric",
                   message: "Charge should be a number",
                 },
               ],
             },
             {
               editorOptions: {
                 showClearButton: true,
               },
               dataField: "refCoderId",
               //  allowEditing: !self.isCoderAudit,
               width: "150",
               caption: "Coder",
               lookup: {
                 dataSource: function(options) {
                   if (!options.data) {
                     return {
                       store: referenceData.lineCoders,
                       filter: options.data
                         ? ["refCoderId", "=", options.data.refCoderId]
                         : null,
                     };
                   } else {
                     return {
                       store: referenceData.lineCoders,
                     };
                   }
                 },
                 displayExpr: "refCoderDescription",
                 valueExpr: "refCoderId",
               },
             },
           ],
         },
         disabled: {
           lineItemColumns: [
             {
               dataField: "revenueCode",
               caption: "Revenue Code",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 48,
                   message: "Revenue Code must be less than 48 characters",
                 },
               ],
             },
             {
               dataField: "cptHcpcsCode",
               editorOptions: editorConfigs.lines.cptHcpcsCode,
               caption: "CPT®/HCPCS",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 48,
                   message: "Procedure Code must be less than 48 characters",
                 },
               ],
             },
             {
               dataField: "procedureModifier1",
               editorOptions: editorConfigs.lines.procedureModifier,
               caption: "Mod",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 2,
                   message: "Mod must be less than 2 characters",
                 },
               ],
             },
             {
               dataField: "procedureModifier2",
               editorOptions: editorConfigs.lines.procedureModifier,
               caption: "Mod",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 2,
                   message: "Mod must be less than 2 characters",
                 },
               ],
             },
             {
               dataField: "procedureModifier3",
               editorOptions: editorConfigs.lines.procedureModifier,
               caption: "Mod",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 2,
                   message: "Mod must be less than 2 characters",
                 },
               ],
             },
             {
               dataField: "procedureModifier4",
               editorOptions: editorConfigs.lines.procedureModifier,
               caption: "Mod",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 2,
                   message: "Mod must be less than 2 characters",
                 },
               ],
             },
             {
               dataField: "fromServiceDateString",
               editorOptions: editorConfigs.lines.fromServiceDateString,
               caption: "Service Date",
               dataType: "date",
             },
             {
               dataField: "serviceUnits",
               dataType: "number",
               caption: "Units",
               alignment: "Center",
               width: 50,
               validationRules: [
                 {
                   type: "numeric",
                   message: "Service units should be a number",
                 },
               ],
             },
             {
               dataField: "totalChargeAmount",
               dataType: "number",
               caption: "Charges",
               format: "currency",
               precision: 2,
               validationRules: [
                 {
                   type: "numeric",
                   message: "Charge should be a number",
                 },
               ],
             },
           ],
         },
       },
     },
     outPatient: {
       diagnoses: [
         {
           dataField: "codeValue",
           caption: "Code",
           editorOptions: editorConfigs.diagnosis.codeValue,
           validationRules: [
             {
               type: "required",
               message: "Diagnoses Code is required",
             },
           ],
         },
       ],
       coderWorkflow: {
         enabled: {
           lineItemColumns: [
             {
               dataField: "revenueCode",
               caption: "Revenue Code",
             },
             {
               dataField: "cptHcpcsCode",
               editorOptions: editorConfigs.lines.cptHcpcsCode,
               caption: "CPT®/HCPCS",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 48,
                   message: "Procedure Code must be less than 48 characters",
                 },
               ],
             },
             {
               dataField: "procedureModifier1",
               editorOptions: editorConfigs.lines.procedureModifier,
               caption: "Mod",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 2,
                   message: "Mod must be less than 2 characters",
                 },
               ],
             },
             {
               dataField: "procedureModifier2",
               editorOptions: editorConfigs.lines.procedureModifier,
               caption: "Mod",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 2,
                   message: "Mod must be less than 2 characters",
                 },
               ],
             },
             {
               dataField: "procedureModifier3",
               editorOptions: editorConfigs.lines.procedureModifier,
               caption: "Mod",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 2,
                   message: "Mod must be less than 2 characters",
                 },
               ],
             },
             {
               dataField: "procedureModifier4",
               editorOptions: editorConfigs.lines.procedureModifier,
               caption: "Mod",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 2,
                   message: "Mod must be less than 2 characters",
                 },
               ],
             },
             {
               dataField: "fromServiceDateString",
               editorOptions: editorConfigs.lines.fromServiceDateString,
               caption: "Service Date",
               dataType: "date",
             },
             {
               dataField: "serviceUnits",
               dataType: "number",
               caption: "Units",
               alignment: "Center",
               width: 50,
               validationRules: [
                 {
                   type: "numeric",
                   message: "Service units should be a number",
                 },
               ],
             },
             {
               dataField: "totalChargeAmount",
               dataType: "number",
               caption: "Charges",
               format: "currency",
               precision: 2,
               validationRules: [
                 {
                   type: "numeric",
                   message: "Charge should be a number",
                 },
               ],
             },
             {
               dataField: "originalPaymentAmt",
               dataType: "number",
               caption: "Original Payment",
               format: "currency",
               precision: 2,
               validationRules: [
                 {
                   type: "numeric",
                   message: "Original Payment Amount should be a number",
                 },
               ],
             },
             {
               editorOptions: {
                 showClearButton: true,
               },
               dataField: "refCoderId",
               //  allowEditing: !self.isCoderAudit,
               width: "150",
               caption: "Coder",
               lookup: {
                 dataSource: function(options) {
                   if (!options.data) {
                     return {
                       store: referenceData.lineCoders,
                       filter: options.data
                         ? ["refCoderId", "=", options.data.refCoderId]
                         : null,
                     };
                   } else {
                     return {
                       store: referenceData.lineCoders,
                     };
                   }
                 },
                 displayExpr: "refCoderDescription",
                 valueExpr: "refCoderId",
               },
             },
           ],
         },
         disabled: {
           lineItemColumns: [
             {
               dataField: "revenueCode",
               caption: "Revenue Code",
             },
             {
               dataField: "cptHcpcsCode",
               editorOptions: editorConfigs.lines.cptHcpcsCode,
               caption: "CPT®/HCPCS",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 48,
                   message: "Procedure Code must be less than 48 characters",
                 },
               ],
             },
             {
               dataField: "procedureModifier1",
               editorOptions: editorConfigs.lines.procedureModifier,
               caption: "Mod",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 2,
                   message: "Mod must be less than 2 characters",
                 },
               ],
             },
             {
               dataField: "procedureModifier2",
               editorOptions: editorConfigs.lines.procedureModifier,
               caption: "Mod",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 2,
                   message: "Mod must be less than 2 characters",
                 },
               ],
             },
             {
               dataField: "procedureModifier3",
               editorOptions: editorConfigs.lines.procedureModifier,
               caption: "Mod",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 2,
                   message: "Mod must be less than 2 characters",
                 },
               ],
             },
             {
               dataField: "procedureModifier4",
               editorOptions: editorConfigs.lines.procedureModifier,
               caption: "Mod",
               validationRules: [
                 {
                   type: "stringLength",
                   min: 0,
                   max: 2,
                   message: "Mod must be less than 2 characters",
                 },
               ],
             },
             {
               dataField: "fromServiceDateString",
               editorOptions: editorConfigs.lines.fromServiceDateString,
               caption: "Service Date",
               dataType: "date",
             },
             {
               dataField: "serviceUnits",
               dataType: "number",
               caption: "Units",
               alignment: "Center",
               width: 50,
               validationRules: [
                 {
                   type: "numeric",
                   message: "Service units should be a number",
                 },
               ],
             },
             {
               dataField: "totalChargeAmount",
               dataType: "number",
               caption: "Charges",
               format: "currency",
               precision: 2,
               validationRules: [
                 {
                   type: "numeric",
                   message: "Charge should be a number",
                 },
               ],
             },
             {
               dataField: "originalPaymentAmt",
               dataType: "number",
               caption: "Original Payment",
               format: "currency",
               precision: 2,
               validationRules: [
                 {
                   type: "numeric",
                   message: "Original Payment Amount should be a number",
                 },
               ],
             },
           ],
         },
       },
     },
   },
   otherThanProfessionalOrHosital: {
     diagnosis: [
       {
         dataField: "codeValue",
         caption: "Code",
         editorOptions: editorConfigs.diagnosis.codeValue,
         validationRules: [
           {
             type: "required",
             message: "Diagnoses Code is required",
           },
         ],
       },
     ],
     lineItemColumns: [
       {
         dataField: "revenueCode",
         caption: "Revenue Code",
         validationRules: [
           {
             type: "stringLength",
             min: 0,
             max: 48,
             message: "Revenue Code must be less than 48 characters",
           },
         ],
       },
       {
         dataField: "cptHcpcsCode",
         editorOptions: editorConfigs.lines.cptHcpcsCode,
         caption: "CPT®/HCPCS",
         validationRules: [
           {
             type: "stringLength",
             min: 0,
             max: 48,
             message: "Procedure Code must be less than 48 characters",
           },
         ],
       },
       {
         dataField: "procedureModifier1",
         editorOptions: editorConfigs.lines.procedureModifier,
         caption: "Mod",
         validationRules: [
           {
             type: "stringLength",
             min: 0,
             max: 2,
             message: "Mod must be less than 2 characters",
           },
         ],
       },
       {
         dataField: "procedureModifier2",
         editorOptions: editorConfigs.lines.procedureModifier,
         caption: "Mod",
         validationRules: [
           {
             type: "stringLength",
             min: 0,
             max: 2,
             message: "Mod must be less than 2 characters",
           },
         ],
       },
       {
         dataField: "procedureModifier3",
         editorOptions: editorConfigs.lines.procedureModifier,
         caption: "Mod",
         validationRules: [
           {
             type: "stringLength",
             min: 0,
             max: 2,
             message: "Mod must be less than 2 characters",
           },
         ],
       },
       {
         dataField: "procedureModifier4",
         editorOptions: editorConfigs.lines.procedureModifier,
         caption: "Mod",
         validationRules: [
           {
             type: "stringLength",
             min: 0,
             max: 2,
             message: "Mod must be less than 2 characters",
           },
         ],
       },
       {
         dataField: "fromServiceDateString",
         editorOptions: editorConfigs.lines.fromServiceDateString,
         caption: "Service Date",
         dataType: "date",
       },
       {
         dataField: "serviceUnits",
         dataType: "number",
         caption: "Units",
         alignment: "Center",
         width: 50,
         validationRules: [
           {
             type: "numeric",
             message: "Service units should be a number",
           },
         ],
       },
       {
         dataField: "totalChargeAmount",
         dataType: "number",
         caption: "Charges",
         format: "currency",
         precision: 2,
         validationRules: [
           {
             type: "numeric",
             message: "Charge should be a number",
           },
         ],
       },
     ],
   },
   linesExtraFields: [
     {
       dataField: "nationalDrugCode",
       caption: "NDC Code",
       validationRules: [
         {
           type: "stringLength",
           min: 0,
           max: 48,
           message: "National Drug Code must be less than 48 characters",
         },
       ],
     },
     {
       dataField: "nationalDrugQuantity",
       caption: "NDC Units",
       validationRules: [
         {
           type: "stringLength",
           min: 0,
           max: 15,
           message: "National Drug Quantity must be less than 15 characters",
         },
       ],
     },
     {
       dataField: "nationalDrugUOM",
       caption: "NDC Unit Qualifier",
       editorOptions: editorConfigs.nationalDrugUOM,
       validationRules: [
         {
           type: "stringLength",
           min: 0,
           max: 2,
           message:
             "National Drug Unit Qualifier must be less than 2 characters",
         },
       ],
     },
     {
       dataField: "ndcRxNo",
       caption: "NDC Rx#",
       validationRules: [
         {
           type: "stringLength",
           min: 0,
           max: 50,
           message:
             "National Drug Prescription Reference Number must be less than 2 characters",
         },
       ],
     },
   ],
 };
};
